module.exports = __webpack_public_path__ + "static/media/joannas.668a030d.jpg";